import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=6b1f7e74&"
import script from "./Orders.vue?vue&type=script&lang=js&"
export * from "./Orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBreadcrumbs,QBreadcrumbsEl,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QInput,QSelect,QTable,QTr,QTh,QTd,QBtn,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QBreadcrumbsEl,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QInput,QSelect,QTable,QTr,QTh,QTd,QBtn})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
